import { useEffect } from 'react';

import EmptyState from '@preqin/ui-components/cjs/core/EmptyState';

import { fireHeapEvent } from '../../utils/heapUtil';

import styles from './PageNotFoundErrorComponent.module.scss';

export const PageNotFoundErrorComponent = () => {
  useEffect(() => {
    fireHeapEvent('Page not found', {}, window.location.pathname);
  }, []);
  return (
    <div className={styles.page}>
      <EmptyState
        header="Page not found"
        image={require('@preqin/ui-components/assets/gifs/NotFound.gif')}
        message="We’re sorry, the data you're looking for seems to be missing. Please check the web address for any spelling mistakes. If you're still having trouble, reach out to our Client Services team for assistance."
        primaryButtonText="Contact support"
        primaryButtonOnClick={() => window.open('https://pro.preqin.com/datasupport', '_blank')}
      />
    </div>
  );
};
